var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:("icon icon-" + _vm.icon)},[_c('use',{attrs:{"href":_vm.svgUrl,"xlink:href":_vm.svgUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }